import { Navigate } from "react-router";

import { OrgControlLogo } from "@/assets/logos/org-control-logo";
import { Button } from "@/components/ui/buttons/button";
import { ROUTES } from "@/constants/routes";
import { useAuth } from "@/providers/auth-provider";

/**
 * Sign-in screen.
 *
 * `login()` passes no organization: the Shadow Realm has its own Kinde
 * environment with a single organization, so authenticating there resolves to
 * it. There is deliberately no "create account" action — an account in this
 * environment is the access gate and must be granted, never self-served.
 */
export const Login = () => {
	const { authError, isAuthenticated, isLoadingAuth, login } = useAuth();

	if (isAuthenticated) {
		return <Navigate replace to={ROUTES.ORGANIZATION_LOCATIONS} />;
	}

	return (
		<div className="flex h-dvh flex-col items-center justify-center gap-4 bg-primary p-6 text-center">
			<OrgControlLogo isMobile />
			<p className="text-md text-secondary">Internal configuration tool.</p>

			<Button
				color="primary"
				isDisabled={isLoadingAuth}
				onClick={() => void login()}
				size="lg"
				type="button"
			>
				{isLoadingAuth ? "Loading…" : "Sign in"}
			</Button>

			{authError && <p className="text-sm text-error-primary">{authError}</p>}
		</div>
	);
};
